"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useRecommendationActions = void 0;
var _reactRedux = require("react-redux");
var _appActions = require("../../store/appActions");
var _uiActions = require("../../store/ui/uiActions");
var _services = require("../../services");
var _uiSelectors = require("../../store/ui/uiSelectors");
var _recommendationActions = require("../../store/recommendation/recommendationActions");
var _widgetSelectors = require("../../store/widget/widgetSelectors");
var _productCatalogActions = require("../../store/productCatalog/productCatalogActions");
var _constants = require("../../utils/constants");
var useRecommendationActions = function useRecommendationActions() {
  var dispatch = (0, _reactRedux.useDispatch)();
  var isCheckoutInProgress = (0, _reactRedux.useSelector)(_uiSelectors.selectIsCheckoutInProgress);
  var _useSelector = (0, _reactRedux.useSelector)(_widgetSelectors.selectUpsellSettings),
    showUpsell = _useSelector.showUpsell,
    upsellTypes = _useSelector.upsellTypes;
  var upsellCategories = upsellTypes.map(function (typeObject) {
    return typeObject.value;
  });
  var onNext = function onNext(_ref) {
    var _selectedHandset$sele, _selectedHandset$sele2, _selectedPlan$selecte, _selectedPlan$selecte2, _selectedBroadband$se, _selectedBroadband$se2, _selectedBusinessSolu, _selectedBusinessSolu2, _selectedBusinessSolu3, _selectedBusinessSolu4, _selectedBusinessSolu5, _selectedHandset$prod, _selectedPlan$product, _selectedBroadband$pr, _selectedBusinessSolu6;
    var selectedHandset = _ref.selectedHandset,
      selectedPlan = _ref.selectedPlan,
      selectedBroadband = _ref.selectedBroadband,
      selectedBusinessSolution = _ref.selectedBusinessSolution;
    var handsetProductId = (_selectedHandset$sele = selectedHandset === null || selectedHandset === void 0 ? void 0 : (_selectedHandset$sele2 = selectedHandset.selectedVariant) === null || _selectedHandset$sele2 === void 0 ? void 0 : _selectedHandset$sele2.variantId) !== null && _selectedHandset$sele !== void 0 ? _selectedHandset$sele : null;
    var planProductId = (_selectedPlan$selecte = selectedPlan === null || selectedPlan === void 0 ? void 0 : (_selectedPlan$selecte2 = selectedPlan.selectedVariant) === null || _selectedPlan$selecte2 === void 0 ? void 0 : _selectedPlan$selecte2.variantId) !== null && _selectedPlan$selecte !== void 0 ? _selectedPlan$selecte : null;
    var broadbandProductId = (_selectedBroadband$se = selectedBroadband === null || selectedBroadband === void 0 ? void 0 : (_selectedBroadband$se2 = selectedBroadband.selectedVariant) === null || _selectedBroadband$se2 === void 0 ? void 0 : _selectedBroadband$se2.variantId) !== null && _selectedBroadband$se !== void 0 ? _selectedBroadband$se : null;
    var businessSolutionId = (_selectedBusinessSolu = selectedBusinessSolution === null || selectedBusinessSolution === void 0 ? void 0 : (_selectedBusinessSolu2 = selectedBusinessSolution.selectedVariant) === null || _selectedBusinessSolu2 === void 0 ? void 0 : _selectedBusinessSolu2.variantId) !== null && _selectedBusinessSolu !== void 0 ? _selectedBusinessSolu : null;
    var handsetProductName = selectedHandset === null || selectedHandset === void 0 ? void 0 : selectedHandset.productName;
    var planProductName = selectedPlan === null || selectedPlan === void 0 ? void 0 : selectedPlan.productName;
    var broadbandProductName = selectedBroadband === null || selectedBroadband === void 0 ? void 0 : selectedBroadband.productName;
    var businessSolutionName = selectedBusinessSolution === null || selectedBusinessSolution === void 0 ? void 0 : selectedBusinessSolution.productName;
    var businessSolutionUrl = selectedBusinessSolution === null || selectedBusinessSolution === void 0 ? void 0 : (_selectedBusinessSolu3 = selectedBusinessSolution.characteristics) === null || _selectedBusinessSolu3 === void 0 ? void 0 : (_selectedBusinessSolu4 = _selectedBusinessSolu3.find(function (c) {
      return c.id === _constants.BUSINESS_SOLUTION_URL_SPEC_NAME;
    })) === null || _selectedBusinessSolu4 === void 0 ? void 0 : (_selectedBusinessSolu5 = _selectedBusinessSolu4.value[0]) === null || _selectedBusinessSolu5 === void 0 ? void 0 : _selectedBusinessSolu5.value;
    var id = "r-".concat(handsetProductId);
    var time = new Date(Date.now());
    var relationshipIds = [];
    selectedHandset === null || selectedHandset === void 0 ? void 0 : (_selectedHandset$prod = selectedHandset.productRelationship) === null || _selectedHandset$prod === void 0 ? void 0 : _selectedHandset$prod.filter(function (relationshipItem) {
      return upsellCategories.includes(relationshipItem.relationshipType);
    }).forEach(function (relationshipItem) {
      relationshipIds.push(relationshipItem.product.id);
    });
    selectedPlan === null || selectedPlan === void 0 ? void 0 : (_selectedPlan$product = selectedPlan.productRelationship) === null || _selectedPlan$product === void 0 ? void 0 : _selectedPlan$product.filter(function (relationshipItem) {
      return upsellCategories.includes(relationshipItem.relationshipType);
    }).forEach(function (relationshipItem) {
      relationshipIds.push(relationshipItem.product.id);
    });
    selectedBroadband === null || selectedBroadband === void 0 ? void 0 : (_selectedBroadband$pr = selectedBroadband.productRelationship) === null || _selectedBroadband$pr === void 0 ? void 0 : _selectedBroadband$pr.filter(function (relationshipItem) {
      return upsellCategories.includes(relationshipItem.relationshipType);
    }).forEach(function (relationshipItem) {
      relationshipIds.push(relationshipItem.product.id);
    });
    selectedBusinessSolution === null || selectedBusinessSolution === void 0 ? void 0 : (_selectedBusinessSolu6 = selectedBusinessSolution.productRelationship) === null || _selectedBusinessSolu6 === void 0 ? void 0 : _selectedBusinessSolu6.filter(function (relationshipItem) {
      return upsellCategories.includes(relationshipItem.relationshipType);
    }).forEach(function (relationshipItem) {
      relationshipIds.push(relationshipItem.product.id);
    });
    var description = handsetProductName;
    dispatch((0, _uiActions.updateTimestamp)({
      id: id,
      time: time,
      description: description
    }));
    if (showUpsell && relationshipIds.length > 0) {
      dispatch((0, _productCatalogActions.fetchProductRelationshipOffering)(relationshipIds));
    } else {
      dispatch((0, _appActions.checkout)({
        handsetProductId: handsetProductId,
        planProductId: planProductId,
        broadbandProductId: broadbandProductId,
        businessSolutionId: businessSolutionId,
        businessSolutionUrl: businessSolutionUrl
      }));
      _services.analytics.endJourney({
        handsetProductName: handsetProductName,
        planProductName: planProductName,
        broadbandProductName: broadbandProductName,
        businessSolutionName: businessSolutionName
      });
    }
  };
  var compareProducts = function compareProducts() {
    dispatch((0, _recommendationActions.goToComparisonPage)());
  };
  return {
    onNext: onNext,
    isCheckoutInProgress: isCheckoutInProgress,
    compareProducts: compareProducts
  };
};
exports.useRecommendationActions = useRecommendationActions;